import React from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDStack } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import PageHeadline from 'Components/ComponentLibrary/Atoms/Text/PageHeadline';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export const DESKTOP_TOP_PADDING = 7;
export const MOBILE_TOP_PADDING = 2;

const PageHeader = ({
  breadcrumbs,
  title,
  subtitle,
  subtitleRichText,
  actions,
  miniHero,
}) => {
  const isMobile = useMobileLayout();

  const SubtitleComponent = subtitleRichText ? Richtext : BodyTextMedium;
  const subtitleComponentProps = subtitleRichText ? { richtext: true } : {};

  let subtitleContent = null;
  if (Array.isArray(subtitle)) {
    subtitleContent = subtitle.map(text => (<SubtitleComponent key={text} value={text} {...subtitleComponentProps} />));
  } else if (subtitle) {
    subtitleContent = <SubtitleComponent value={subtitle} {...subtitleComponentProps} />;
  }

  return (
    <Box paddingTop={isMobile ? MOBILE_TOP_PADDING : DESKTOP_TOP_PADDING} paddingBottom={2}>
      <FDStack
        direction={isMobile ? 'column' : 'row'}
        spacing={isMobile ? 2 : 6}
        justifyContent="space-between"
        alignItems={isMobile ? 'flex-start' : 'center'}
      >
        <FDStack direction="column" spacing={1} flex={1}>
          <FDStack justifyContent="space-between" spacing={2}>
            <Box
              flex={1} // Prefer for this left side to take up more of the screen
              flexBasis={300}
            >
              {breadcrumbs}
              <PageHeadline value={title} />
            </Box>

            {isMobile ? null : actions}
          </FDStack>

          {subtitleContent && (
          <FDBox paddingY={1}>
            {subtitleContent}
          </FDBox>
          )}

          {isMobile ? actions : null}
        </FDStack>
        {miniHero ? (
          <FDStack alignSelf={isMobile ? 'flex-end' : 'flex-start'} maxWidth={isMobile ? undefined : '350px'} wrap>
            {miniHero}
          </FDStack>
        ) : null}
      </FDStack>
    </Box>
  );
};

PageHeader.defaultProps = {
  miniHero: null,
  breadcrumbs: undefined,
  subtitle: undefined,
  subtitleRichText: false,
  actions: null,
};

PageHeader.propTypes = {
  miniHero: PropTypes.node,
  breadcrumbs: PropTypes.object,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  subtitleRichText: PropTypes.bool,
  actions: PropTypes.node,
};

export default PageHeader;
